// extracted by mini-css-extract-plugin
export var content = "_d3-3";
export var list = "_d3-4";
export var settingsContent = "_d3-7";
export var settingsPanel = "_d3-8";
export var state = "_d3-6";
export var triggerBadge = "_d3-2";
export var triggerButton = "_d3-1";
export var triggerShell = "_d3-0";
export var unreadDot = "_d3-5";